export const queryKeys = {
  monitorStatus: ['monitor', 'status'],
  statsByName: ['stats', 'byName'],
  statsByProcess: ['stats', 'byProcess'],
  historicalByName: ['historical', 'byName'],
  historicalByProcess: ['historical', 'byProcess'],
  recentChanges: (limit: number) => ['recent-changes', limit] as const,
  config: ['config'],
  searches: ['searches'],
  me: (userId: string) => ['me', userId] as const,
} as const;
